// extracted by mini-css-extract-plugin
export default {"customerChatRoomContentSec":"CustomerChatRoom_customerChatRoomContentSec__hGBB-","customerChatRoomSendSec":"CustomerChatRoom_customerChatRoomSendSec__tkS-H"};